import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer, Cell } from "recharts";
import Icon from "components/AppIcon";

const data = [
  { range: "$280K–$310K", count: 3, label: "$280–310K" },
  { range: "$310K–$340K", count: 6, label: "$310–340K" },
  { range: "$340K–$370K", count: 9, label: "$340–370K" },
  { range: "$370K–$400K", count: 12, label: "$370–400K" },
  { range: "$400K–$430K", count: 8, label: "$400–430K" },
  { range: "$430K–$460K", count: 5, label: "$430–460K" },
  { range: "$460K–$490K", count: 2, label: "$460–490K" },
];

const SUBJECT_PRICE = 385000;

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-card border border-border rounded-lg px-3 py-2 shadow-lg">
      <p className="text-xs font-caption font-semibold text-foreground">{label}</p>
      <p className="text-xs font-caption text-muted-foreground">{payload?.[0]?.value} properties</p>
    </div>
  );
};

export default function PriceDistributionChart() {
  return (
    <div className="card-base p-0 overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center gap-2">
        <Icon name="BarChart2" size={15} color="var(--color-primary)" />
        <span className="font-heading font-semibold text-sm text-foreground">Price Distribution</span>
        <span className="text-xs font-caption text-muted-foreground ml-auto">Last 90 days · Omaha Metro</span>
      </div>
      <div className="p-4">
        <div className="w-full h-48" aria-label="Price distribution bar chart for comparable properties">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 8, right: 8, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
              <XAxis dataKey="label" tick={{ fontSize: 10, fill: "var(--color-muted-foreground)", fontFamily: "Inter" }} tickLine={false} axisLine={false} />
              <YAxis tick={{ fontSize: 10, fill: "var(--color-muted-foreground)", fontFamily: "Inter" }} tickLine={false} axisLine={false} />
              <Tooltip content={<CustomTooltip />} />
              <ReferenceLine x="$370–400K" stroke="var(--color-primary)" strokeDasharray="4 2" strokeWidth={2} label={{ value: "Subject", position: "top", fontSize: 10, fill: "var(--color-primary)", fontFamily: "Inter" }} />
              <Bar dataKey="count" radius={[4, 4, 0, 0]}>
                {data?.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={entry?.label === "$370–400K" ? "var(--color-primary)" : "var(--color-muted)"}
                    stroke={entry?.label === "$370–400K" ? "var(--color-primary)" : "var(--color-border)"}
                    strokeWidth={1}
                  />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="flex items-center gap-4 mt-2 text-xs font-caption text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded bg-primary" />
            <span>Subject price range</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div className="w-3 h-3 rounded bg-muted border border-border" />
            <span>Market distribution</span>
          </div>
        </div>
      </div>
    </div>
  );
}